import { fetchTagById, fetchTags } from '../../../services/api/tags';
import { AsyncSelect } from '../AsyncSelect/AsyncSelect';

import type { CnpTag } from '../../../types';
import type { AsyncSelectProps } from '../AsyncSelect/AsyncSelect';
import type { FC } from 'react';

type Props = Omit<
  AsyncSelectProps<CnpTag>,
  'fetchMany' | 'fetchOne' | 'mapItemToOption'
>;

const mapItemToOption = ({
  id,
  title,
}: {
  id: string | number;
  title: string;
}) => ({
  value: id.toString(),
  label: title,
});

const searchTags = (query: string) => fetchTags({ query });

const TagsSelect: FC<Props> = (props) => {
  return (
    <AsyncSelect
      fetchMany={searchTags}
      fetchOne={fetchTagById}
      mapItemToOption={mapItemToOption}
      {...props}
    />
  );
};

export { TagsSelect };
